export default __webpack_public_path__ + "static/media/SSS_referral_image.8d548e53.jpg";